module.exports = {
          srcSet: __webpack_public_path__ + "32f93d1c4cb217f689fcb78ec06bfc73-64.png"+" 64w",
          images:[ {path: __webpack_public_path__ + "32f93d1c4cb217f689fcb78ec06bfc73-64.png",width: 64,height: 65}],
          src: __webpack_public_path__ + "32f93d1c4cb217f689fcb78ec06bfc73-64.png",
          toString:function(){return __webpack_public_path__ + "32f93d1c4cb217f689fcb78ec06bfc73-64.png"},
          
          width: 64,
          height: 65
        }